import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import PageHero from '../../../components/feature/sections/PageHero';
import TrustBar from '../../../components/feature/sections/TrustBar';
import ServiceDetails from './components/ServiceDetails';
import AIAnswerBlock, { AIAnswerItem } from '../../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../../components/feature/sections/ServiceAreas';
import Testimonials from '../../../components/feature/sections/Testimonials';
import FAQSection, { FAQItem } from '../../../components/feature/sections/FAQSection';
import FinalCTA from '../../../components/feature/sections/FinalCTA';

const aiItems: AIAnswerItem[] = [
  {
    question: 'What is carpet installation?',
    answer: 'Carpet installation involves preparing the subfloor, precisely measuring the space, cutting carpet to fit, and professionally stretching and securing it for a smooth, durable finish. Proper installation ensures comfort, insulation, and long-term performance across all room types.',
  },
  {
    question: 'What types of carpet does Value Carpet Inc install?',
    answer: 'Value Carpet Inc installs plush/saxony carpet, berber/loop pile, frieze/textured carpet, carpet tiles, marine-grade carpet, and specialty turf — for residential rooms, commercial spaces, boats, and specialty environments throughout New Jersey.',
  },
  {
    question: 'Do you offer commercial carpet installation?',
    answer: 'Yes. Value Carpet Inc handles commercial carpet installations including carpet tiles and broadloom carpet for offices, retail spaces, hospitality venues, and large commercial environments — with solutions built for durability and high traffic.',
  },
  {
    question: 'How is carpet installation priced?',
    answer: 'Carpet installation cost depends on the type of carpet, room size, subfloor condition, and any required prep work. Value Carpet Inc offers free consultations to provide accurate, transparent pricing tailored to your specific project.',
  },
];

const faqs: FAQItem[] = [
  {
    q: 'Is carpet better than hardwood flooring?',
    a: 'Carpet provides superior comfort, insulation, and noise reduction — ideal for bedrooms and living areas. Hardwood offers durability and a premium aesthetic. The best choice depends on the room, lifestyle, and personal preference. Both can be installed by Value Carpet Inc.',
  },
  {
    q: 'How long does carpet installation take?',
    a: 'Most carpet installations are completed in one day. Larger homes or rooms requiring subfloor preparation may take longer. Value Carpet Inc provides timeline estimates during the free consultation to help you plan accordingly.',
  },
  {
    q: 'Who provides carpet installation near Freehold, NJ?',
    a: 'Value Carpet Inc provides professional carpet installation in Freehold and throughout Monmouth County, NJ. Their team handles residential and commercial carpet installs — from room measurements to final stretching and inspection.',
  },
  {
    q: 'Can carpet be installed over existing flooring?',
    a: 'In many cases, yes — carpet can be installed over existing subfloor or smooth, level surfaces. However, proper subfloor preparation is critical for longevity. Value Carpet Inc assesses subfloor conditions before every installation.',
  },
  {
    q: 'Do you offer carpet replacement and removal?',
    a: 'Yes. Value Carpet Inc handles full carpet replacement including removal of existing carpet, subfloor preparation, and installation of new carpet — leaving your home clean, fresh, and beautifully finished.',
  },
];

export default function CarpetServicePage() {
  return (
    <div className="min-h-screen bg-cream font-sans">
      <Navbar />
      <main>
        <PageHero
          title="Professional Carpet Installation in New Jersey"
          subtitle="From plush residential carpet to commercial carpet tiles and marine-grade specialty flooring — expertly installed for lasting comfort and performance."
          tag="Carpet Installation · Freehold, NJ"
          imageSrc="https://public.readdy.ai/ai/img_res/107c0532ee74ecaaec99e12f9a9f57a0.jpg"
          imageAlt="Professional carpet installation New Jersey"
        />
        <TrustBar />
        <ServiceDetails />
        <AIAnswerBlock title="Carpet Installation — Explained" items={aiItems} />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQSection title="Carpet Installation FAQs" faqs={faqs} />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
